import { Attachment, AttachmentUploadConfig, ProgressHandler } from '../../store/Attachment';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getAttachmentConfig = () => {
  return apiService.callExternalApi<AttachmentUploadConfig>({
    url: `${API_SERVER_URL}/attachments/config`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getAttachments = (entityId: string, entityType: string) => {
  return apiService.callExternalApi<Attachment[]>({
    url: `${API_SERVER_URL}/attachments/entity/${entityId}/type/${entityType}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const uploadAttachmentData = (
  file: File,
  entityId: string,
  entityType: string,
  progressHandler: ProgressHandler,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('entityId', entityId);
  formData.append('entityType', entityType);
  return apiService.callExternalApi<Attachment>({
    url: `${API_SERVER_URL}/attachments`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    onUploadProgress: progressHandler,
    signal
  });
};

export const archiveAttachmentData = (id: string) => {
  return apiService.callExternalApi<Attachment>({
    url: `${API_SERVER_URL}/attachments/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};

export const downloadAttachmentData = (id: string) => {
  return apiService.callExternalApi<Blob>({
    url: `${API_SERVER_URL}/attachments/${id}/download`,
    method: 'GET',
    responseType: 'blob'
  });
};
